import { ACTION_TYPE } from './action';

// region Reducer
const roleList = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_SELECT_ROLES_SUCCESS:
      return {
        ...state,
        stores: action.stores,
      };
    case ACTION_TYPE.CALL_API_ROLES_SEARCH_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.CALL_API_ROLE_DELETE_SUCCESS:
      return {
        ...state,
        isDeleteSuccess: true,
      };
    case ACTION_TYPE.SET_ROLE_LIST_SEARCH_CONDITION:
      return {
        ...state,
        searchCondition: action.searchCondition,
      };
    case ACTION_TYPE.RESET_ROLE_LIST_FLG:
      return {
        ...state,
        isDeleteSuccess: false,
      };
    default:
      return state;
  }
};

export default roleList;
